import { ReportFeatures } from '@hcs/types';

export const REPORT_PUBLIC_LINK_EDITABLE_FEATURES = [
  ReportFeatures.EditableLinks,
];
